<template>
  <section class="project-files-list-page">
    <div class="container-fluid">
      <div
        class="project-files-list-page__card"
        :style="{
          'background-color': isMobileVersion && isTreeVisible ? 'var(--light)' : 'var(--white)'
        }"
      >
        <div
          v-if="isMobileVersion"
          class="text-muted font-weight-bolder f4 px-2 pt-2"
          @click="onSwitchTabClick"
        >
          <i
            class="mr-2"
            :class="switchActiveBlockIcon"
          />
          <span>{{ switchActiveBlockText }}</span>
        </div>
        <project-files-tree
          :style="treeDisplay"
          :is-new-repo="isNewRepo"
        />
        <project-file-edit
          v-if="$route?.name === 'project-file-edit'"
          :style="filesDisplay"
          ref="projectFileEdit"
          @submit="onSubmit"
        />
        <project-file-create
          v-else-if="$route?.name === 'project-file-create'"
          :is-new-repo="isNewRepo"
          :style="filesDisplay"
          ref="projectFileCreate"
          @submit="onSubmit"
        />
        <project-files-list
          v-else
          :style="filesDisplay"
        />
      </div>
    </div>
  </section>
</template>

<script>
import ProjectFilesTree from '@/shared-modules/modules/project-files/components/project-files-tree';
import ProjectFilesList from '@/shared-modules/modules/project-files/components/project-files-list';
import projectFilesMessages from '@/shared-modules/modules/project-files/project-files.messages';
import ProjectFileEdit from '@/shared-modules/modules/project-files/components/project-file-edit';
// eslint-disable-next-line max-len
import ProjectFileCreate from '@/shared-modules/modules/project-files/components/project-file-create';

export default {
  // eslint-disable-next-line vue/match-component-file-name
  name: 'ProjectFiles',
  components: { ProjectFilesTree, ProjectFilesList, ProjectFileEdit, ProjectFileCreate },
  data() {
    return {
      isTreeVisible: true,
      isFilesVisible: true,
      isMobileVersion: false,
      isSubmitEvent: false
    };
  },
  computed: {
    switchActiveBlockIcon() {
      if (this.isTreeVisible) return ' gf-icon gf-icon-arrow-right';
      return ' gf-icon gf-icon-arrow-left';
    },
    switchActiveBlockText() {
      if (this.isTreeVisible) return this.$t('file.content');
      return this.$t('file.files');
    },
    treeDisplay() {
      if (this.isTreeVisible) return { display: 'block' };
      return { display: 'none' };
    },
    filesDisplay() {
      if (this.isFilesVisible) return { display: 'block' };
      return { display: 'none' };
    },
    isNewRepo() {
      return !!this.$route.query.isNewRepo;
    }
  },
  beforeRouteLeave(to, from, next) {
    next(this.startPageLeaveConfirm());
  },
  watch: {
    '$route.query.file': function () {
      if (this.isMobileVersion && this.isTreeVisible) {
        this.isTreeVisible = false;
        this.isFilesVisible = true;
      }
    }
  },
  mounted() {
    if (!this.$route.query.branch && !this.$route.query.commit) {
      const currentBranchInput = document.getElementById('currentBranch');
      if (currentBranchInput?.value) {
        this.$router.push({
          query: {
            ...this.$route.query,
            branch: currentBranchInput.value
          }
        });
      }
    }
    if (window.innerWidth < 768) {
      this.isMobileVersion = true;
      this.isTreeVisible = false;
    }
    window.addEventListener('beforeunload', this.onWindowBeforeUnload);
  },
  methods: {
    onSwitchTabClick() {
      this.isTreeVisible = !this.isTreeVisible;
      this.isFilesVisible = !this.isFilesVisible;
    },
    onSubmit() {
      this.isSubmitEvent = true;
    },
    confirmRouteLeave() {
      const discardIsConfirmed = confirm('Вы уверены, что хотите отменить внесенные изменения?');
      return discardIsConfirmed;
    },
    startPageLeaveConfirm() {
      const from = this.$route?.name;
      if (from === 'project-file-edit' && this.$refs.projectFileEdit.fileHasChanges) {
        return this.confirmRouteLeave();
      } else if (from === 'project-file-create') {
        return this.confirmRouteLeave();
      } else {
        return true;
      }
    },
    onWindowBeforeUnload(e) {
      if (!this.isSubmitEvent) {
        if (!this.startPageLeaveConfirm()) e.preventDefault();
      }
    }
  },
  beforeDestroy() {
    window.removeEventListener('beforeunload', this.onWindowBeforeUnload);
  },
  i18n: { messages: projectFilesMessages }
};
</script>

<style lang="scss">
$this: '.project-files-list-page';

#{$this}__card {
  min-height: 85dvh;
  display: flex;
  flex-wrap: wrap;
  border: 1px solid var(--border-color);
  border-radius: var(--border-radius-lg);

  @media screen and (max-width: 992px) {
    min-height: auto;
  }
}
</style>
